import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { NavService } from './nav-service';
import { PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class FormationsNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }
  liste = this.makeNavigator(EparcoursPath.root.FORMATIONS);

  // ============================FORMATION SIMPLE ========================================
  creationSimple = this.makeNavigator(EparcoursPath.root.FORMATIONS, EparcoursPath.formations.CREATION_SIMPLE);

  edition_simple = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_SIMPLE,
    PARAM_TOKEN,
    EparcoursPath.formations.EDITION_GENERAL,
  );

  tarifs_simple = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_SIMPLE,
    PARAM_TOKEN,
    EparcoursPath.formations.TARIFS,
  );

  sessions_simple = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_SIMPLE,
    PARAM_TOKEN,
    EparcoursPath.formations.EDITION_SESSIONS,
  );

  creation_session_simple = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_SIMPLE,
    PARAM_TOKEN,
    EparcoursPath.formations.CREATION_SESSION);


  evaluations_simple = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_SIMPLE,
    PARAM_TOKEN,
    EparcoursPath.formations.EVALUATIONS
  )
  questionnaire_simple = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_SIMPLE, PARAM_TOKEN,
    EparcoursPath.formations.QUESTIONNAIRE
  );


  // ============================FORMATION COMPOSE ========================================

  creationCompose = this.makeNavigator(EparcoursPath.root.FORMATIONS, EparcoursPath.formations.CREATION_COMPOSE);

  edition_parcours = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.EDITION_PARCOURS,
  );

  edition_parcours_compose = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.EDITION_PARCOURS_COMPOSE,
  );

  creation_parcours = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.CREATION_PARCOURS);

  creation_parcours_compose = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.CREATION_PARCOURS_COMPOSE);

  edition_compose = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.EDITION_GENERAL,
  );

  tarifs_compose = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.TARIFS,
  );

  referentiel_compose  = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.MODULES
  )

  evaluations_compose  = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE,
    PARAM_TOKEN,
    EparcoursPath.formations.EVALUATIONS
  )

  questionnaire_compose = this.makeNavigatorWithParam(
    EparcoursPath.root.FORMATIONS,
    EparcoursPath.formations.EDITION_COMPOSE, PARAM_TOKEN,
    EparcoursPath.formations.QUESTIONNAIRE
  );
}
